module.exports = __webpack_public_path__ + "img/h5-dowb.eee8048a.png";